import { ChartConfig } from './ChartConfig';
import { ChartStyle } from './ChartStyle';

export class DonutChartConfig extends ChartConfig {
  label?: string;

  style: ChartStyle = {};

  paddingForLabels = 0;

  total?: number;

  comparisonTotal?: number;
}
